(function(){
    angular
        .module('appback')
        .directive('ngPedido', pedido);
        pedido.$inject = ['HojaService','StockService','$timeout', 'Upload'];
        function pedido(HojaService,StockService,$timeout, Upload){
            return {
	            //require: 'ngModel',
              templateUrl: '/backend/pedidos/template?name=general.twig',
		        scope: {
                    pc:'=',
                },
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {
			        });
		        }
          }
      }
})();